import { useCallback } from "react";
import * as R from "ramda";
import { useNavigate } from "react-router-dom-v5-compat";

import { useCreateProject } from "queries/projects";
import { useRequirement } from "queries/requirements";

const useGetStarted = (guide) => {
  const navigate = useNavigate();
  const { id: guideID, intake_requirement_id: intakeRequirementID, is_intake: isIntake } = guide;
  // Intake Guides: https://github.com/opencounter/opencounter/issues/4667
  const { data: intakeRequirement } = useRequirement(intakeRequirementID, {
    enabled: !!isIntake,
  });
  const requirementIDs = R.reject(R.isNil, [intakeRequirementID]);
  let onSuccess;
  if (isIntake && intakeRequirement) {
    onSuccess = (project) => {
      if (intakeRequirement.direct_to_handoff) {
        navigate(`/projects/${project.id}/apply`);
      } else {
        navigate(`/projects/${project.id}/direct/${intakeRequirement.slug}`);
      }
    };
  }
  const { mutate } = useCreateProject({ onSuccess });

  const createProject = useCallback(() => {
    mutate({ guide_id: guideID, requirement_ids: requirementIDs });
  }, [mutate, guideID, requirementIDs]);

  if (isIntake && !intakeRequirement) {
    return null;
  }

  return createProject;
};

export default useGetStarted;
